import { customCampaignForm } from "@hardware/Services/CampaignService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

type SubmitCampaignFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

const fieldToApiKey: Record<string, string> = {
    companyName: "CompanyName",
    firstName: "FirstName",
    lastName: "LastName",
    businessEmail: "EmailAddress",
    additionalInfo: "AdditionalInfo",
};

type HandlerType = ApiHandlerDiscreteParameter<SubmitCampaignFormParameter, Record<string, string>>;

export const PopulateApiParameter: HandlerType = props => {
    const states = props.getState() as any;
    const state = states.campaignForm as any;

    const formData: Record<string, string> = {
        EmailTo: props.parameter.emailRecipients,
        Topic: "Lead Generation",
    };

    for (const key in state.fieldValues) {
        const value = state.fieldValues[key];
        const apiKey = fieldToApiKey[key] ?? key[0].toUpperCase() + key.slice(1);
        if (value) {
            formData[apiKey] = value;
        }
    }

    const emailAddress = formData.EmailAddress ?? "";
    const firstName = formData.FirstName ?? "";
    formData.AuthKey = emailAddress + firstName;

    props.apiParameter = formData;
};

export const SendDataToApi: HandlerType = async props => {
    await customCampaignForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitCampaignForm = createHandlerChainRunner(chain, "CampaignForm");
export default submitCampaignForm;
